/* =========================================================
   Walaky · Ruleta de descuentos
   Todo el comportamiento vive en este archivo. Los textos,
   colores de los premios y la URL de la API se configuran
   en el bloque CONFIG de acá abajo — no deberías necesitar
   tocar nada más abajo de eso para ajustes normales.
   ========================================================= */

(function () {
  "use strict";

  const CONFIG = {
    // URL de tu Edge Function de Supabase.
    API_URL: "https://hygbawjtqdazhxgzpmmm.supabase.co/functions/v1/callToApiWhell",
    // La "anon key" de tu proyecto (Settings > API en Supabase).
    // Es pública por diseño, está pensada para vivir en el frontend.
    ANON_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh5Z2Jhd2p0cWRhemh4Z3pwbW1tIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODgxMjYyNDMsImV4cCI6MjEwMzcwMjI0M30.3HUKLYKil7_DbX_Q8z-I_J3kY0IXI0s27Pp22ht3Las",

    // Los dos premios de la rueda. "weight" define qué tan grande
    // es cada porción visualmente — debe reflejar la probabilidad
    // real que decide el servidor (20% / 80%) para que la rueda
    // no "mienta" visualmente.
    SEGMENTS: [
      {
        type: "perdiste",
        label: "Sigue\nintentando",
        weight: 20,
        fill: "#0e3f28ff",
        textColor: "#ffffff",
      },
      {
        type: "ganaste",
        label: "10% OFF",
        weight: 80,
        fill: "#83a07dff",
        textColor: "#ffffff",
      },
    ],

    // Popup automático al cargar la página.
    AUTO_OPEN: {
      enabled: true,
      delayMs: 4000, // espera 4s antes de mostrarlo, para no ser agresivo
    },
  };

  // Regex simple pero real de validación de email (usuario@dominio.tld)
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  // Cuánto tiempo recordamos en este navegador que el usuario ya jugó,
  // para no volver a mostrarle el formulario de email innecesariamente.
  const STORAGE_KEY = "wp_walaky_state";
  const STORAGE_TTL_MS = 12 * 60 * 60 * 1000; // 12 horas

  // Si el usuario cierra el popup SIN jugar, esperamos este tiempo antes
  // de volver a mostrárselo automáticamente (el botón manual sigue
  // funcionando siempre, esto solo frena el auto-popup).
  const DISMISS_KEY = "wp_walaky_dismissed_until";
  const DISMISS_COOLDOWN_MS = 24 * 60 * 60 * 1000; // 24 horas

  // ---------------------------------------------------------
  // Referencias al DOM
  // ---------------------------------------------------------
  const trigger = document.getElementById("wp-trigger"); // opcional
  const overlay = document.getElementById("wheel-promo");
  if (!overlay) return; // el HTML de la ruleta no está en la página

  const card = overlay.querySelector(".wp-card");
  const views = {
    email: overlay.querySelector('[data-wp-view="email"]'),
    wheel: overlay.querySelector('[data-wp-view="wheel"]'),
    result: overlay.querySelector('[data-wp-view="result"]'),
  };

  const emailForm = overlay.querySelector("[data-wp-email-form]");
  const emailInput = overlay.querySelector("#wp-email");
  const honeypotInput = overlay.querySelector("#wp-company");
  const emailError = overlay.querySelector("[data-wp-email-error]");
  const emailSubmitBtn = overlay.querySelector("[data-wp-email-submit]");
  const emailSubmitLabel = overlay.querySelector("[data-wp-submit-label]");

  const wheelSvg = overlay.querySelector("[data-wp-wheel-svg]");
  const spinBtn = overlay.querySelector("[data-wp-spin-btn]");

  const resultIcon = overlay.querySelector("[data-wp-result-icon]");
  const resultTitle = overlay.querySelector("[data-wp-result-title]");
  const resultText = overlay.querySelector("[data-wp-result-text]");
  const codeBox = overlay.querySelector("[data-wp-code-box]");
  const codeEl = overlay.querySelector("[data-wp-code]");
  const copyBtn = overlay.querySelector("[data-wp-copy-btn]");

  // Guarda el resultado que ya decidió el servidor, para usarlo
  // cuando termine la animación del giro.
  let pendingResult = null;
  let wheelBuilt = false;

  // ---------------------------------------------------------
  // Caché local: recuerda el resultado por 12h para no repetir
  // el flujo completo si el usuario vuelve a abrir la ruleta.
  // ---------------------------------------------------------
  function readCachedState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed?.expiresAt || Date.now() > parsed.expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed;
    } catch (err) {
      // Si localStorage no está disponible (modo privado, bloqueado, etc.)
      // simplemente seguimos sin caché — no es un error crítico.
      return null;
    }
  }

  function writeCachedState(resultData) {
    try {
      const payload = {
        ...resultData,
        expiresAt: Date.now() + STORAGE_TTL_MS,
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (err) {
      // Sin caché no pasa nada grave, solo se pierde la comodidad
      // de no repetir el flujo — el servidor sigue siendo la fuente
      // real de verdad de si ya jugó o no.
    }
  }

  function setDismissCooldown() {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now() + DISMISS_COOLDOWN_MS));
    } catch (err) {
      /* no-op */
    }
  }

  function isInDismissCooldown() {
    try {
      const until = Number(localStorage.getItem(DISMISS_KEY));
      return Boolean(until) && Date.now() < until;
    } catch (err) {
      return false;
    }
  }

  // ---------------------------------------------------------
  // Construcción del SVG de la rueda a partir de CONFIG.SEGMENTS
  // ---------------------------------------------------------
  function polarPoint(cx, cy, r, angleDeg) {
    const rad = (angleDeg * Math.PI) / 180;
    return {
      x: cx + r * Math.sin(rad),
      y: cy - r * Math.cos(rad),
    };
  }

  function buildWheel() {
    const cx = 150;
    const cy = 150;
    const r = 148;
    const totalWeight = CONFIG.SEGMENTS.reduce((sum, s) => sum + s.weight, 0);

    let angle = 0;
    const svgNS = "http://www.w3.org/2000/svg";

    CONFIG.SEGMENTS.forEach((segment) => {
      const sweep = (segment.weight / totalWeight) * 360;
      const startAngle = angle;
      const endAngle = angle + sweep;
      segment.centerAngle = startAngle + sweep / 2;

      const p1 = polarPoint(cx, cy, r, startAngle);
      const p2 = polarPoint(cx, cy, r, endAngle);
      const largeArc = sweep > 180 ? 1 : 0;

      const path = document.createElementNS(svgNS, "path");
      path.setAttribute(
        "d",
        `M ${cx} ${cy} L ${p1.x} ${p1.y} A ${r} ${r} 0 ${largeArc} 1 ${p2.x} ${p2.y} Z`
      );
      path.setAttribute("fill", segment.fill);
      path.setAttribute("stroke", "#fbf8f1");
      path.setAttribute("stroke-width", "2");
      wheelSvg.appendChild(path);

      // Texto del premio, centrado en la porción
      const textPoint = polarPoint(cx, cy, r * 0.62, segment.centerAngle);
      const lines = segment.label.split("\n");
      const text = document.createElementNS(svgNS, "text");
      text.setAttribute("x", textPoint.x);
      text.setAttribute("y", textPoint.y);
      text.setAttribute("fill", segment.textColor);
      text.setAttribute("font-size", "16");
      text.setAttribute("text-anchor", "middle");
      text.setAttribute("dominant-baseline", "middle");

      lines.forEach((line, i) => {
        const tspan = document.createElementNS(svgNS, "tspan");
        tspan.setAttribute("x", textPoint.x);
        tspan.setAttribute("dy", i === 0 ? `${-(lines.length - 1) * 0.55}em` : "1.1em");
        tspan.textContent = line;
        text.appendChild(tspan);
      });

      wheelSvg.appendChild(text);
      angle = endAngle;
    });

    wheelBuilt = true;
  }

  // ---------------------------------------------------------
  // Abrir / cerrar el modal
  // ---------------------------------------------------------
  function openOverlay() {
    overlay.hidden = false;
    // pequeño delay para que la transición de opacidad se dispare
    requestAnimationFrame(() => overlay.classList.add("wp-is-open"));
    document.body.style.overflow = "hidden";

    // Si ya jugó en las últimas 12h en este navegador, le mostramos
    // su resultado directo en vez de hacerlo repetir el formulario.
    const cached = readCachedState();
    if (cached) {
      wheelSvg.style.transition = "none";
      wheelSvg.style.transform = "rotate(0deg)";
      showResult(cached, { skipCache: true });
    } else {
      showView("email");
    }
  }

  function closeOverlay() {
    // Si cierra sin haber visto el resultado (email o rueda a medias),
    // no lo molestamos con el auto-popup por 24h. Si ya vio el
    // resultado, el caché de 12h ya se encarga de eso.
    if (views.result.hidden) {
      setDismissCooldown();
    }

    overlay.classList.remove("wp-is-open");
    document.body.style.overflow = "";
    setTimeout(() => {
      overlay.hidden = true;
      resetToEmailView();
    }, 250);
  }

  function showView(name) {
    Object.entries(views).forEach(([key, el]) => {
      el.hidden = key !== name;
    });
  }

  function resetToEmailView() {
    showView("email");
    emailForm.reset();
    setEmailError("");
    setEmailLoading(false);
    spinBtn.disabled = false;
    wheelSvg.style.transition = "none";
    wheelSvg.style.transform = "rotate(0deg)";
    pendingResult = null;
  }

  // ---------------------------------------------------------
  // Vista de email
  // ---------------------------------------------------------
  function setEmailError(message) {
    if (!message) {
      emailError.hidden = true;
      emailError.textContent = "";
      return;
    }
    emailError.hidden = false;
    emailError.textContent = message;
  }

  function setEmailLoading(isLoading) {
    emailSubmitBtn.disabled = isLoading;
    emailSubmitLabel.textContent = isLoading ? "Comprobando..." : "Quiero girar";
  }

  async function handleEmailSubmit(event) {
    event.preventDefault();
    setEmailError("");

    // Si el campo trampa viene lleno, es un bot rellenando el
    // formulario automáticamente. No mandamos nada al servidor.
    if (honeypotInput && honeypotInput.value.trim() !== "") {
      return;
    }

    const email = emailInput.value.trim();
    if (!EMAIL_REGEX.test(email)) {
      setEmailError("Ingresa un correo válido.");
      return;
    }

    setEmailLoading(true);

    try {
      const response = await fetch(CONFIG.API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${CONFIG.ANON_KEY}`,
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json().catch(() => null);

      if (!response.ok || !data) {
        setEmailError("Algo salió mal. Intenta de nuevo en un momento.");
        return;
      }

      if (data.success === false && data.status === "ALREADY_PLAYED") {
        setEmailError("Este correo ya participó en la ruleta.");
        return;
      }

      if (!data.success) {
        setEmailError("No pudimos procesar tu participación. Intenta de nuevo.");
        return;
      }

      // Guardamos el resultado real (ya decidido por el servidor)
      // para revelarlo cuando termine la animación del giro.
      pendingResult = data;

      if (!wheelBuilt) buildWheel();
      showView("wheel");
    } catch (err) {
      setEmailError("No pudimos conectar con el servidor. Revisa tu conexión.");
    } finally {
      setEmailLoading(false);
    }
  }

  // ---------------------------------------------------------
  // Vista de la rueda: animación del giro
  // ---------------------------------------------------------
  function handleSpin() {
    if (!pendingResult) return;

    spinBtn.disabled = true;

    const won = pendingResult.result === "GANASTE";
    const targetSegment = CONFIG.SEGMENTS.find((s) =>
      won ? s.type === "ganaste" : s.type === "perdiste"
    );

    // Un poco de aleatoriedad dentro de la porción para que no
    // siempre caiga exactamente en el centro (se ve más natural).
    const segmentSweep =
      (targetSegment.weight /
        CONFIG.SEGMENTS.reduce((sum, s) => sum + s.weight, 0)) *
      360;
    const jitter = (Math.random() - 0.5) * segmentSweep * 0.5;

    const fullSpins = 5; // vueltas completas antes de frenar, solo efecto visual
    const rotation =
      fullSpins * 360 + ((360 - targetSegment.centerAngle - jitter) % 360);

    wheelSvg.style.transition = "transform 4.2s cubic-bezier(0.17, 0.89, 0.24, 1)";
    wheelSvg.style.transform = `rotate(${rotation}deg)`;

    wheelSvg.addEventListener("transitionend", onSpinEnd, { once: true });
  }

  function onSpinEnd() {
    showResult(pendingResult);
  }

  // ---------------------------------------------------------
  // Vista de resultado
  // ---------------------------------------------------------
  const ICON_CHECK = `<svg viewBox="0 0 24 24" fill="none"><path d="M5 12.5L10 17.5L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const ICON_LEAF = `<svg viewBox="0 0 24 24" fill="none"><path d="M5 19C5 12 9 5 19 5C19 15 12 19 5 19Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M5 19C9 15 12 12 19 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>`;

  function spawnHeartBurst(container, count = 12) {
    for (let i = 0; i < count; i++) {
      const heart = document.createElement("span");
      heart.className = "wp-heart wp-heart--burst";

      const angle = (i / count) * Math.PI * 2 + Math.random() * 0.4;
      const distance = 70 + Math.random() * 50;
      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance - 20;

      heart.style.setProperty("--wp-burst-x", `${x}px`);
      heart.style.setProperty("--wp-burst-y", `${y}px`);
      heart.style.animationDelay = `${Math.random() * 0.15}s`;

      container.appendChild(heart);
      setTimeout(() => heart.remove(), 1700);
    }
  }

  function showResult(data, options = {}) {
    const won = data.result === "GANASTE";

    resultIcon.innerHTML = won ? ICON_CHECK : ICON_LEAF;
    resultIcon.classList.toggle("wp-is-win", won);

    if (won) {
      resultTitle.textContent = "¡Ganaste 10% de descuento!";
      if (data.shopifyStatus === "failed") {
        // El premio quedó registrado pero el código todavía no
        // se sincronizó con la tienda. Evitamos mostrar un código
        // que no existe todavía en Shopify.
        resultText.textContent =
          "Tu premio quedó registrado. Escríbenos con tu correo y te confirmamos tu código.";
        codeBox.hidden = true;
      } else {
        resultText.textContent = "Usa este código en tu próxima compra.";
        codeEl.textContent = data.discountCode;
        codeBox.hidden = false;
      }
    } else {
      resultTitle.textContent = "Por esta vez no hubo suerte";
      resultText.textContent = "Gracias por participar, vuelve pronto a intentarlo.";
      codeBox.hidden = true;
    }

    showView("result");

    if (won && !options.skipCache) {
      spawnHeartBurst(views.result);
    }

    if (!options.skipCache) {
      writeCachedState(data);
    }
  }

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(codeEl.textContent);
      copyBtn.textContent = "¡Copiado!";
      copyBtn.classList.add("wp-is-copied");
      setTimeout(() => {
        copyBtn.textContent = "Copiar código";
        copyBtn.classList.remove("wp-is-copied");
      }, 1800);
    } catch (err) {
      // Si el navegador bloquea el portapapeles, al menos el
      // código ya está visible en pantalla para copiarlo a mano.
    }
  }

  // ---------------------------------------------------------
  // Listeners
  // ---------------------------------------------------------
  if (trigger) {
    trigger.addEventListener("click", openOverlay);
  }
  overlay.querySelectorAll("[data-wp-close]").forEach((btn) =>
    btn.addEventListener("click", closeOverlay)
  );
  overlay.querySelector("[data-wp-close-final]").addEventListener("click", closeOverlay);

  overlay.addEventListener("click", (event) => {
    if (event.target === overlay) closeOverlay();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && overlay.classList.contains("wp-is-open")) {
      closeOverlay();
    }
  });

  emailForm.addEventListener("submit", handleEmailSubmit);
  spinBtn.addEventListener("click", handleSpin);
  copyBtn.addEventListener("click", handleCopy);

  // ---------------------------------------------------------
  // Auto-apertura al cargar la página
  // ---------------------------------------------------------
  function maybeAutoOpen() {
    if (!CONFIG.AUTO_OPEN.enabled) return;
    if (overlay.classList.contains("wp-is-open")) return; // ya está abierto

    // No molestar si ya jugó recientemente (el botón manual igual
    // le mostraría su premio si quiere verlo).
    if (readCachedState()) return;

    // No molestar si cerró el popup sin jugar hace poco.
    if (isInDismissCooldown()) return;

    setTimeout(openOverlay, CONFIG.AUTO_OPEN.delayMs);
  }

  maybeAutoOpen();
})();